import i18n from 'asset/translation';

const INTERNAL_TRANSLATION_KEY_REGEX = /^\$\{([\w.]+)\}$/;

/**
 * Resolves internally editable names/titles (e.g. report template names or analysis titles)
 * that were set by us to a translatable placeholder in the form `${path.to.key}`.
 *
 * The path is looked up under the `internalTranslationKeys` translation namespace
 * (see src/asset/translation/internalTranslationKeys/en_US.json). If the given value
 * doesn't match the placeholder pattern, or the key doesn't exist, the original value is
 * returned untouched so customer-provided names are never altered.
 */
export const resolveInternalTranslationKey = (value: string): string => {
    const match = value?.match(INTERNAL_TRANSLATION_KEY_REGEX);
    if (!match) return value;

    const translationKey = `internalTranslationKeys.${match[1]}`;
    return i18n.exists(translationKey) ? i18n.t(translationKey) : value;
};

export default resolveInternalTranslationKey;
